<template>
  <div class="section std gallery d-flex is-align-items-center is-justify-content-center">
    <div class="section-container">
      <div class="content">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-md-12">
              <h2>{{ trans.get('public.home.materials.special-materials') }}</h2>
            </div>
            <div class="col-lg-12 col-xl-6">
              <div class="titolo">
                <img src="/media/icons/svg/properties.svg" alt=""/>
                <h6>{{ trans.get('public.home.materials.tough') }}</h6>
              </div>
              <p>
                {{ trans.get('public.home.materials.desc4') }}

              </p>
            </div>
            <div class="col-lg-12 col-xl-6">
              <div class="titolo">
                <img src="/media/icons/svg/antistatic.svg" alt=""/>
                <h6>{{ trans.get('public.home.materials.antistatic') }}</h6>
              </div>
              <p>
                {{ trans.get('public.home.materials.desc3') }}

              </p>
            </div>
            <div class="col-lg-12 col-xl-6">
              <div class="titolo">
                <img src="/media/icons/svg/highly_tough_reinforc.svg" alt=""/>
                <h6>{{ trans.get('public.home.materials.extra-clear') }}</h6>
              </div>
              <p>
                {{ trans.get('public.home.materials.desc6') }}

              </p>
            </div>
            <div class="col-lg-12 col-xl-6">
              <div class="titolo">
                <img src="/media/icons/svg/metal_detect.svg" alt=""/>
                <h6>{{ trans.get('public.home.materials.metal-detectable') }}</h6>
              </div>
              <p>
                {{ trans.get('public.home.materials.desc5') }}
              </p>
            </div>
            <div class="col-lg-12 col-xl-6">
              <div class="titolo">
                <img src="/media/icons/svg/extra clear.svg" alt=""/>
                <h6> {{ trans.get('public.home.materials.properties') }}</h6>
              </div>
              <p>
                {{ trans.get('public.home.materials.desc2') }}
              </p>
            </div>
            <div class="col-lg-12 col-xl-6">
              <div class="titolo">
                <img src="/media/icons/svg/co-extruded.svg" alt=""/>
                <h6> {{ trans.get('public.home.materials.co-extruded') }}</h6>
              </div>
              <p>
                {{ trans.get('public.home.materials.desc7') }}

              </p>
            </div>
            <div class="col-lg-12 col-xl-6">
              <div class="titolo">
                <img src="/media/icons/svg/suerface_finishes.svg" alt=""/>
                <h6>{{ trans.get('public.home.materials.surface-finishes') }}</h6>
              </div>
              <p>
                {{ trans.get('public.home.materials.desc8') }}

              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "materials-2.vue",
  components: {},
  data() {
    return {};
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.section {
  background-color: #3b3b43;
  font-size: 0.9em;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }
  padding-top: 50px !important;
  padding-bottom: 0;
   @media (max-width: 576px) {
    padding-top: 50px !important;
  }

  .container {
    height: calc(100vh - 80px);
    width: 100%;
    max-width: 100% !important;
    padding: 0;

    .row {
      width: 90%;
      max-width: 90%;
    }
  }

  h2,
  h6 {
    color: #fff !important;
  }

  .section-container {
    margin-bottom: 10px;
  }

  color: #fff !important;

  .titolo {
    display: flex;
    align-items: center;
    margin: 30px 0 20px;

    img {
      margin-right: 0.5rem;
    }

    h6 {
      margin: 0;
    }
  }

  p {

  }
}

@media (max-width: 576px) {
  .container, .content, .section-container, .section.std {
    height: 100% !important;
  }
  .section {
    padding: 25px 0;

    .section-container {
      .content {
        .container {

          padding: 0;

          h2 {
            font-size: 18px;
            margin-bottom: 20px;
          }

          [class^=col-] {
            padding: 0;
            margin: 0 17px;
            margin-bottom: 20px;
          }

          .titolo {
            h6 {
              font-size: 18px;
            }

            margin-bottom: 12px;
          }

        }
      }
    }
  }
}

@media (min-width: 1921px) {
  .section {
    padding-top: 100px!important;
  }
 .section .container {
   height: 100%;
 }
}
@media (min-width: 2000px) and (min-height: 800px) {
  .section.std.gallery {
    padding-top: 0!important;

  }
}
</style>
